module.exports = __webpack_public_path__ + "img/world-sm.bba2655e.svg";